// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/app-home/sec2/slick-prev.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/app-home/sec2/slick-next.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-sec-2 {
    position: relative;
    padding: 10px;
    width: 100%;
    top: 15rem;
    margin-top: -7rem !important;
    margin-bottom: 20rem;
  }
  /* .gallery-sec-2 .slick-slider{
    height: 200px;
  } */
  
.gallery-sec-2 .slick-prev::before{
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transition: all 0.3s ease;
  }
.gallery-sec-2 .slick-next::before{
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    transition: all 0.3s ease;
  }
  .gallery-sec-2 .slick-next:hover,
    .gallery-sec-2 .slick-prev:hover {
    color: red; 
    }

  .gallery-sec-2 .slick-next::before,.gallery-sec-2 .slick-prev::before{
    margin: 0 -10px;
  }
  .gallery-sec-2 .slick-next, .gallery-sec-2 .slick-prev{
    top: -4rem;
  }
  .gallery-sec-2 .slick-next{
    /* right: 68px; */
    right: 22px;
    
  }
  .gallery-sec-2 .slick-prev{
    left: calc( 100vw - 285px);
  }

  .gallery-imgs{
    margin-top: 7rem;
  }

  .img-video{
    z-index: 1;
    position: absolute;
    color: #ffff;
    top: 11rem;
    left: 7.8%;
    font-weight: 400;
    font-family: 'Poppins';
  }
  .img-video button{
    border: none;
    background: none;
    color: white;
    font-weight: 400  ;
    font-size: 16px;
  }


  
  .img.active, .video.active {
    font-weight: 600;
  }
  .img-video .img{
    padding-right: 2rem;
  }
  .img-video .video{
    padding-left: 2rem !important;
  }

  .slider-info{
    position: absolute;
    color: #ffff;
    top: -4rem;
    left: 1rem;
    font-weight: 400;
    font-family: Peddana;
  }
  .slider-info .current-no{
    font-size: 32px;
  }
  .slider-info .total-no{
    font-size: 20px;
    color: #9F9D9D;
  }


  .gallery-sec-2 .img-popup {
    position: fixed;
    z-index: 999;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 0;
    width: 0;
    opacity: 0;
    transition: all ease 0.9s;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .gallery-sec-2 .img-popup.show {
    opacity: 1;
    max-height: calc(100vh - 20px);
    width: fit-content;
    height: fit-content;
    left: 50%; 
    transition: all ease 0.9s;
    
  }
  
  .gallery-sec-2 .img-popup img {
    border-radius: 10px;
    object-fit: contain;
    max-height: calc(100vh - 100px); 
    max-width: calc(100vw - 500px);
    width: auto;
    height: auto;
  }
  .gallery-sec-2 .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    fill: #fff;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.918));
    cursor: pointer;
  }
  .gallery-sec-2 img{
    margin-bottom: 0 !important;
  }


@media (min-width:1400px) {
    /* .gallery-sec-2 .slick-next{
        right: 68px;
      } */
      .gallery-sec-2 .slick-prev{
        left: calc( 100vw - 360px);
      }
}

@media (max-width:992px) {
    .gallery-sec-2 .slick-prev::before, .gallery-sec-2 .slick-next::before{
        display: none;
    }
    .gallery-sec-2 .img-popup img{
      max-width: calc(100vw - 120px);
      max-height: calc(100vh - 150px);
    }
    /* .img-video {
      left: 2rem;
    } */
    /* .gallery-sec-2{
        margin-top: 2rem !important;
      } */
    
}

@media (max-width: 576px) {
  .img-video {
    left: 24px;
  }
  .gallery-sec-2 {
    top: 10rem;
  }
  .img-video button{
    font-size: 13px;
  }
  .img-video{
    top: 7rem;
  }
  
}

`, "",{"version":3,"sources":["webpack://./src/common-componets/GallerySlider.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;;KAEG;;AAEL;IACI,gDAA8D;IAC9D,yBAAyB;EAC3B;AACF;IACI,gDAA8D;IAC9D,yBAAyB;EAC3B;EACA;;IAEE,UAAU;IACV;;EAEF;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,WAAW;;EAEb;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;;;EAIA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,cAAc;EAChB;;;EAGA;IACE,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,SAAS;IACT,QAAQ;IACR,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,yBAAyB;;EAE3B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;IAC/B,8BAA8B;IAC9B,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,qDAAqD;IACrD,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;;;AAGF;IACI;;SAEK;MACH;QACE,0BAA0B;MAC5B;AACN;;AAEA;IACI;QACI,aAAa;IACjB;IACA;MACE,8BAA8B;MAC9B,+BAA+B;IACjC;IACA;;OAEG;IACH;;SAEK;;AAET;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;;AAEF","sourcesContent":[".gallery-sec-2 {\r\n    position: relative;\r\n    padding: 10px;\r\n    width: 100%;\r\n    top: 15rem;\r\n    margin-top: -7rem !important;\r\n    margin-bottom: 20rem;\r\n  }\r\n  /* .gallery-sec-2 .slick-slider{\r\n    height: 200px;\r\n  } */\r\n  \r\n.gallery-sec-2 .slick-prev::before{\r\n    content: url(../../public/images/app-home/sec2/slick-prev.svg);\r\n    transition: all 0.3s ease;\r\n  }\r\n.gallery-sec-2 .slick-next::before{\r\n    content: url(../../public/images/app-home/sec2/slick-next.svg);\r\n    transition: all 0.3s ease;\r\n  }\r\n  .gallery-sec-2 .slick-next:hover,\r\n    .gallery-sec-2 .slick-prev:hover {\r\n    color: red; \r\n    }\r\n\r\n  .gallery-sec-2 .slick-next::before,.gallery-sec-2 .slick-prev::before{\r\n    margin: 0 -10px;\r\n  }\r\n  .gallery-sec-2 .slick-next, .gallery-sec-2 .slick-prev{\r\n    top: -4rem;\r\n  }\r\n  .gallery-sec-2 .slick-next{\r\n    /* right: 68px; */\r\n    right: 22px;\r\n    \r\n  }\r\n  .gallery-sec-2 .slick-prev{\r\n    left: calc( 100vw - 285px);\r\n  }\r\n\r\n  .gallery-imgs{\r\n    margin-top: 7rem;\r\n  }\r\n\r\n  .img-video{\r\n    z-index: 1;\r\n    position: absolute;\r\n    color: #ffff;\r\n    top: 11rem;\r\n    left: 7.8%;\r\n    font-weight: 400;\r\n    font-family: 'Poppins';\r\n  }\r\n  .img-video button{\r\n    border: none;\r\n    background: none;\r\n    color: white;\r\n    font-weight: 400  ;\r\n    font-size: 16px;\r\n  }\r\n\r\n\r\n  \r\n  .img.active, .video.active {\r\n    font-weight: 600;\r\n  }\r\n  .img-video .img{\r\n    padding-right: 2rem;\r\n  }\r\n  .img-video .video{\r\n    padding-left: 2rem !important;\r\n  }\r\n\r\n  .slider-info{\r\n    position: absolute;\r\n    color: #ffff;\r\n    top: -4rem;\r\n    left: 1rem;\r\n    font-weight: 400;\r\n    font-family: Peddana;\r\n  }\r\n  .slider-info .current-no{\r\n    font-size: 32px;\r\n  }\r\n  .slider-info .total-no{\r\n    font-size: 20px;\r\n    color: #9F9D9D;\r\n  }\r\n\r\n\r\n  .gallery-sec-2 .img-popup {\r\n    position: fixed;\r\n    z-index: 999;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    height: 0;\r\n    width: 0;\r\n    opacity: 0;\r\n    transition: all ease 0.9s;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .gallery-sec-2 .img-popup.show {\r\n    opacity: 1;\r\n    max-height: calc(100vh - 20px);\r\n    width: fit-content;\r\n    height: fit-content;\r\n    left: 50%; \r\n    transition: all ease 0.9s;\r\n    \r\n  }\r\n  \r\n  .gallery-sec-2 .img-popup img {\r\n    border-radius: 10px;\r\n    object-fit: contain;\r\n    max-height: calc(100vh - 100px); \r\n    max-width: calc(100vw - 500px);\r\n    width: auto;\r\n    height: auto;\r\n  }\r\n  .gallery-sec-2 .close-icon {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    width: 24px;\r\n    height: 24px;\r\n    fill: #fff;\r\n    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.918));\r\n    cursor: pointer;\r\n  }\r\n  .gallery-sec-2 img{\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n\r\n@media (min-width:1400px) {\r\n    /* .gallery-sec-2 .slick-next{\r\n        right: 68px;\r\n      } */\r\n      .gallery-sec-2 .slick-prev{\r\n        left: calc( 100vw - 360px);\r\n      }\r\n}\r\n\r\n@media (max-width:992px) {\r\n    .gallery-sec-2 .slick-prev::before, .gallery-sec-2 .slick-next::before{\r\n        display: none;\r\n    }\r\n    .gallery-sec-2 .img-popup img{\r\n      max-width: calc(100vw - 120px);\r\n      max-height: calc(100vh - 150px);\r\n    }\r\n    /* .img-video {\r\n      left: 2rem;\r\n    } */\r\n    /* .gallery-sec-2{\r\n        margin-top: 2rem !important;\r\n      } */\r\n    \r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .img-video {\r\n    left: 24px;\r\n  }\r\n  .gallery-sec-2 {\r\n    top: 10rem;\r\n  }\r\n  .img-video button{\r\n    font-size: 13px;\r\n  }\r\n  .img-video{\r\n    top: 7rem;\r\n  }\r\n  \r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
